import { useRecoilValue } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import LoginButtonTemplateV3 from "./LoginButtonTemplateV3";
import useGoogleLoginV3 from "./useGoogleLoginV3";
import useAutoLoginV3 from "./useAutoLoginV3";

export default function GoogleLoginButtonV3({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  useAutoLoginV3();
  const user = useRecoilValue(userSimpleAtom);
  const { handleGoogleLogin, isLoading } = useGoogleLoginV3();

  return (
    <LoginButtonTemplateV3
      loginType="google"
      action={handleGoogleLogin}
      isLoggedIn={!!user?.accessToken}
      isLoading={isLoading}
    />
  );
}
